import {useAppState} from 'store/utils';

export function useLastRecalcDateTimeStore(): LastRecalcDateTimeState {
  return useAppState().lastRecalcDateTime;
}
